import { ADD_REPORT_PAGE_FAIL, ADD_REPORT_PAGE_REQUEST, ADD_REPORT_PAGE_SUCCESS, CHANGE_DEFAULT_REPORT_FAIL, CHANGE_DEFAULT_REPORT_REQUEST, CHANGE_DEFAULT_REPORT_SUCCESS, CLEAR_REPORT_DETAILS, CREATE_REPORT_FAIL, CREATE_REPORT_REQUEST, CREATE_REPORT_SUCCESS, DELETE_REPORT_FAIL, DELETE_REPORT_PAGE_FAIL, DELETE_REPORT_PAGE_REQUEST, DELETE_REPORT_PAGE_SUCCESS, DELETE_REPORT_REQUEST, DELETE_REPORT_SUCCESS, DUPLICATE_PAGE_FAIL, DUPLICATE_PAGE_REQUEST, DUPLICATE_PAGE_SUCCESS, DUPLICATE_REPORT_FAIL, DUPLICATE_REPORT_REQUEST, DUPLICATE_REPORT_SUCCESS, GET_DEFAULT_REPORT_FAIL, GET_DEFAULT_REPORT_REQUEST, GET_DEFAULT_REPORT_SUCCESS, GET_REPORT_DETAILS_FAIL, GET_REPORT_DETAILS_REQUEST, GET_REPORT_DETAILS_SUCCESS, GET_REPORT_LIST_FAIL, GET_REPORT_LIST_REQUEST, GET_REPORT_LIST_SUCCESS, GET_STAGE_FAIL, GET_STAGE_REQUEST, GET_STAGE_SUCCESS, GET_SURVEY_DATA_REQUEST, GET_UTM_VARIABLE_FAIL, GET_UTM_VARIABLE_REQUEST, GET_UTM_VARIABLE_SUCCESS, REORDER_PAGE_FAIL, REORDER_PAGE_REQUEST, REORDER_PAGE_SUCCESS, SET_CURRENT_REPORT, START_EDIT_MODE, STOP_EDIT_MODE, UPDATE_CUSTOM_FORMULA_FAIL, UPDATE_CUSTOM_FORMULA_REQUEST, UPDATE_CUSTOM_FORMULA_SUCCESS, UPDATE_CUSTOM_VARIABLE_FAIL, UPDATE_CUSTOM_VARIABLE_REQUEST, UPDATE_CUSTOM_VARIABLE_STATUS_FAIL, UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST, UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS, UPDATE_CUSTOM_VARIABLE_SUCCESS, UPDATE_PAGE_FAIL, UPDATE_PAGE_REQUEST, UPDATE_PAGE_SUCCESS, UPDATE_REPORT_NAME_FAIL, UPDATE_REPORT_NAME_REQUEST, UPDATE_REPORT_NAME_SUCCESS, UPDATE_STAGE_FAIL, UPDATE_STAGE_REQUEST, UPDATE_STAGE_SUCCESS, UPDATE_UTM_VARIABLE_FAIL, UPDATE_UTM_VARIABLE_REQUEST, UPDATE_UTM_VARIABLE_SUCCESS } from "../constant"

const initialState = {
  isEditMode: true,
  currentReport: null,
  reportData: [],
  defaultReport: {},
  reportDetails: null,
}

const reportReducer = (state = initialState, action) => {
  switch (action.type) {

    //Edit mode
    case START_EDIT_MODE:
      return {
        ...state,
        isEditMode: true
      }
    case STOP_EDIT_MODE:
      return {
        ...state,
        isEditMode: false
      }

    //Current report
    case SET_CURRENT_REPORT:
      return {
        ...state,
        currentReport: action.payload
      }

    //Create report
    case CREATE_REPORT_REQUEST:
      return {
        ...state,
      }
    case CREATE_REPORT_SUCCESS:
      return {
        ...state,
      }
    case CREATE_REPORT_FAIL:
      return {
        ...state,
      }

    //Get report details
    case GET_REPORT_DETAILS_REQUEST:
      return {
        ...state,
      }
    case GET_REPORT_DETAILS_SUCCESS:
      return {
        ...state,
        reportDetails: action.payload
      }
    case GET_REPORT_DETAILS_FAIL:
      return {
        ...state,
      }
    case CLEAR_REPORT_DETAILS:
      return {
        ...state,
        reportDetails: null
      }

    //Get report list
    case GET_REPORT_LIST_REQUEST:
      return {
        ...state,
        reportData: [],
      }
    case GET_REPORT_LIST_SUCCESS:
      return {
        ...state,
        reportData: action.payload,
      }
    case GET_REPORT_LIST_FAIL:
      return {
        ...state,
        reportData: [],
      }

    //Add page in report
    case ADD_REPORT_PAGE_REQUEST:
      return {
        ...state,
      }
    case ADD_REPORT_PAGE_SUCCESS:
      let tmpReportDetails = { ...state.reportDetails }
      let tmpPages = [...tmpReportDetails?.reportPages]
      tmpPages.push(action.payload)
      tmpReportDetails.reportPages = tmpPages
      return {
        ...state,
        reportDetails: { ...tmpReportDetails }
      }
    case ADD_REPORT_PAGE_FAIL:
      return {
        ...state,
      }

    //Change report name
    case UPDATE_REPORT_NAME_REQUEST:
      return {
        ...state,
      }
    case UPDATE_REPORT_NAME_SUCCESS:
      let data = action.payload
      let tmpData = { ...state.reportDetails?.reportData }
      tmpData = { ...tmpData, su_survey_report_name: JSON.stringify({ [data.language_code]: data.name }) }
      return {
        ...state,
        reportDetails: { ...state.reportDetails, reportData: { ...tmpData } }
      }
    case UPDATE_REPORT_NAME_FAIL:
      return {
        ...state,
      }

    //Delete page
    case DELETE_REPORT_PAGE_REQUEST:
      return {
        ...state,
      }
    case DELETE_REPORT_PAGE_SUCCESS:
      let tmpReportPages = [...state.reportDetails?.reportPages]
      tmpReportPages = tmpReportPages?.filter((page) => {
        return Number(page.id) !== Number(action.payload)
      })
      return {
        ...state,
        reportDetails: { ...state.reportDetails, reportPages: [...tmpReportPages] }
      }
    case DELETE_REPORT_PAGE_FAIL:
      return {
        ...state,
      }


    //Delete report
    case DELETE_REPORT_REQUEST:
      return {
        ...state,
      }
    case DELETE_REPORT_SUCCESS:
      let tmpReports = [...state.reportData]
      tmpReports = tmpReports?.filter((report) => {
        return Number(report.su_survey_report_id) !== Number(action.payload)
      })
      return {
        ...state,
        reportData: tmpReports
      }
    case DELETE_REPORT_FAIL:
      return {
        ...state,
      }


    //Duplicate report
    case DUPLICATE_REPORT_REQUEST:
      return {
        ...state,
      }
    case DUPLICATE_REPORT_SUCCESS:
      let reportData = { ...action.payload }
      let newReports = [...state.reportData]

      newReports.push({
        su_survey_report_id: reportData.id,
        su_survey_report_name: JSON.stringify({ [reportData.language_code]: reportData.report_name })
      })

      return {
        ...state,
        reportData: newReports
      }
    case DUPLICATE_REPORT_FAIL:
      return {
        ...state,
      }


    //Duplicate page
    case DUPLICATE_PAGE_REQUEST:
      return {
        ...state,
      }
    case DUPLICATE_PAGE_SUCCESS:
      let newPages = state.reportDetails?.reportPages ? [...state.reportDetails?.reportPages] : []
      newPages.push({
        ...action.payload
      })
      console.log({
        ...action.payload
      })
      return {
        ...state,
        reportDetails: { ...state.reportDetails, reportPages: [...newPages] }
      }

    case DUPLICATE_PAGE_FAIL:
      return {
        ...state,
      }


    //Update page
    case UPDATE_PAGE_REQUEST:
      return {
        ...state,
      }
    case UPDATE_PAGE_SUCCESS:
      let editedReportPages = state.reportDetails?.reportPages ? [...state.reportDetails?.reportPages] : []
      editedReportPages = editedReportPages?.map((page) => {
        if (Number(page.id) === Number(action.payload?.page_id)) {
          page = { ...page, content: action.payload?.content, css: action.payload?.css }
        }
        return { ...page }
      })
      return {
        ...state,
        reportDetails: { ...state.reportDetails, reportPages: [...editedReportPages] }
      }
    case UPDATE_PAGE_FAIL:
      return {
        ...state,
      }

    //Update page
    case REORDER_PAGE_REQUEST:
      return {
        ...state,
      }
    case REORDER_PAGE_SUCCESS:
      const pageOrder = action.payload.order
      let tmpNewPages = state.reportDetails?.reportPages ? [...state.reportDetails?.reportPages] : []
      tmpNewPages = tmpNewPages?.map((page) => {
        return { ...page, page_no: pageOrder[page.id] }
      })
      return {
        ...state,
        reportDetails: { ...state.reportDetails, reportPages: [...tmpNewPages] }
      }
    case REORDER_PAGE_FAIL:
      return {
        ...state,
      }

    //Get default report
    case GET_DEFAULT_REPORT_REQUEST:
      return {
        ...state,
        defaultReport: {}
      }
    case GET_DEFAULT_REPORT_SUCCESS:
      const tmpDefaultReport = action.payload && action.payload[0]
      return {
        ...state,
        defaultReport: tmpDefaultReport ?? {}
      }
    case GET_DEFAULT_REPORT_FAIL:
      return {
        ...state,
        defaultReport: {}
      }

    //Update default report
    case CHANGE_DEFAULT_REPORT_REQUEST:
      return {
        ...state,
      }
    case CHANGE_DEFAULT_REPORT_SUCCESS:
      return {
        ...state,
        defaultReport: action.payload
      }
    case CHANGE_DEFAULT_REPORT_FAIL:
      return {
        ...state,
      }

    //Default
    default:
      return state;
  }
}

export { reportReducer }